/**
 * 18 Risk Categories Configuration
 * Based on CN117292825A Patent - 18项风险评估系统
 */

export const RISK_SYSTEMS = {
    NERVOUS: {
        id: 'nervous',
        name: 'Thần kinh',
        name_cn: '神经系统',
        icon: '🧠',
        color: '#8B5CF6' // Purple
    },
    CARDIOVASCULAR: {
        id: 'cardiovascular',
        name: 'Tim mạch',
        name_cn: '心血管系统',
        icon: '❤️',
        color: '#EF4444' // Red
    },
    DIGESTIVE: {
        id: 'digestive',
        name: 'Tiêu hóa',
        name_cn: '消化系统',
        icon: '🫃',
        color: '#F59E0B' // Amber
    },
    FUNCTIONAL: {
        id: 'functional',
        name: 'Chức năng',
        name_cn: '功能系统',
        icon: '⚡',
        color: '#10B981' // Emerald
    },
    METABOLIC: {
        id: 'metabolic',
        name: 'Chuyển hóa',
        name_cn: '代谢系统',
        icon: '🔄',
        color: '#3B82F6' // Blue
    }
};

export const RISK_CATEGORIES = {
    // Nervous System (3)
    stress: {
        id: 'stress',
        name: 'Áp lực',
        name_cn: '压力风险',
        system: 'NERVOUS',
        icon: '😰',
        description: 'Rủi ro stress và căng thẳng tâm lý',
        tcm_syndromes: ['Can uất khí trệ', 'Tâm hỏa kháng thịnh']
    },
    fatigue: {
        id: 'fatigue',
        name: 'Mệt mỏi',
        name_cn: '疲劳风险',
        system: 'NERVOUS',
        icon: '😴',
        description: 'Rủi ro mệt mỏi và suy nhược',
        tcm_syndromes: ['Khí hư', 'Tỳ hư đàm thấp']
    },
    sleep_quality: {
        id: 'sleep_quality',
        name: 'Giấc ngủ',
        name_cn: '睡眠质量风险',
        system: 'NERVOUS',
        icon: '🌙',
        description: 'Rủi ro chất lượng giấc ngủ',
        tcm_syndromes: ['Tâm thận bất giao', 'Âm hư hỏa vượng']
    },

    // Cardiovascular System (4)
    cardiovascular: {
        id: 'cardiovascular',
        name: 'Tim mạch',
        name_cn: '心血管风险',
        system: 'CARDIOVASCULAR',
        icon: '💔',
        description: 'Rủi ro bệnh tim mạch',
        tcm_syndromes: ['Huyết ứ', 'Khí trệ huyết ứ']
    },
    cerebrovascular: {
        id: 'cerebrovascular',
        name: 'Não mạch',
        name_cn: '脑血管风险',
        system: 'CARDIOVASCULAR',
        icon: '🧠',
        description: 'Rủi ro đột quỵ và tai biến',
        tcm_syndromes: ['Can dương thượng kháng', 'Phong đàm trở lạc']
    },
    blood_pressure: {
        id: 'blood_pressure',
        name: 'Huyết áp',
        name_cn: '血压风险',
        system: 'CARDIOVASCULAR',
        icon: '📈',
        description: 'Rủi ro tăng huyết áp',
        tcm_syndromes: ['Can dương thượng kháng', 'Âm hư dương kháng']
    },
    dyslipidemia: {
        id: 'dyslipidemia',
        name: 'Mỡ máu',
        name_cn: '血脂风险',
        system: 'CARDIOVASCULAR',
        icon: '🧈',
        description: 'Rủi ro rối loạn lipid máu',
        tcm_syndromes: ['Đàm thấp nội uẩn', 'Tỳ hư đàm thấp']
    },

    // Digestive System (3)
    digestive_capacity: {
        id: 'digestive_capacity',
        name: 'Tiêu hóa',
        name_cn: '消化能力风险',
        system: 'DIGESTIVE',
        icon: '🫃',
        description: 'Rủi ro suy giảm chức năng tiêu hóa',
        tcm_syndromes: ['Tỳ khí hư', 'Tỳ vị hư hàn']
    },
    gerd: {
        id: 'gerd',
        name: 'Trào ngược',
        name_cn: '胃食道逆流风险',
        system: 'DIGESTIVE',
        icon: '🔥',
        description: 'Rủi ro trào ngược dạ dày-thực quản',
        tcm_syndromes: ['Can khí phạm vị', 'Vị nhiệt xí thịnh']
    },
    hyperacidity: {
        id: 'hyperacidity',
        name: 'Dư axit',
        name_cn: '胃酸过多风险',
        system: 'DIGESTIVE',
        icon: '🧪',
        description: 'Rủi ro dư axit dạ dày',
        tcm_syndromes: ['Can vị uất nhiệt', 'Vị âm hư']
    },

    // Functional System (4)
    liver_burden: {
        id: 'liver_burden',
        name: 'Gánh nặng gan',
        name_cn: '肝负担风险',
        system: 'FUNCTIONAL',
        icon: '🫀',
        description: 'Rủi ro gánh nặng chức năng gan',
        tcm_syndromes: ['Can uất khí trệ', 'Can đởm thấp nhiệt']
    },
    kidney_burden: {
        id: 'kidney_burden',
        name: 'Gánh nặng thận',
        name_cn: '肾负担风险',
        system: 'FUNCTIONAL',
        icon: '🫘',
        description: 'Rủi ro gánh nặng chức năng thận',
        tcm_syndromes: ['Thận dương hư', 'Thận âm hư']
    },
    endocrine: {
        id: 'endocrine',
        name: 'Nội tiết',
        name_cn: '内分泌风险',
        system: 'FUNCTIONAL',
        icon: '🦋',
        description: 'Rủi ro rối loạn nội tiết',
        tcm_syndromes: ['Âm hư hỏa vượng', 'Dương hư']
    },
    calcium_deficiency: {
        id: 'calcium_deficiency',
        name: 'Thiếu canxi',
        name_cn: '缺钙风险',
        system: 'FUNCTIONAL',
        icon: '🦴',
        description: 'Rủi ro thiếu canxi và loãng xương',
        tcm_syndromes: ['Thận tinh khuy hư', 'Can thận âm hư']
    },

    // Metabolic System (4)
    blood_sugar: {
        id: 'blood_sugar',
        name: 'Đường huyết',
        name_cn: '血糖风险',
        system: 'METABOLIC',
        icon: '🍬',
        description: 'Rủi ro đường huyết cao / tiểu đường',
        tcm_syndromes: ['Âm hư táo nhiệt', 'Khí âm lưỡng hư']
    },
    immune_capacity: {
        id: 'immune_capacity',
        name: 'Miễn dịch',
        name_cn: '免疫力风险',
        system: 'METABOLIC',
        icon: '🛡️',
        description: 'Rủi ro suy giảm miễn dịch',
        tcm_syndromes: ['Khí hư', 'Vệ khí bất cố']
    },
    allergy: {
        id: 'allergy',
        name: 'Dị ứng',
        name_cn: '过敏风险',
        system: 'METABOLIC',
        icon: '🤧',
        description: 'Rủi ro dị ứng và quá mẫn',
        tcm_syndromes: ['Phế vệ bất cố', 'Đặc bẩm chất']
    },
    obesity: {
        id: 'obesity',
        name: 'Béo phì',
        name_cn: '肥胖风险',
        system: 'METABOLIC',
        icon: '⚖️',
        description: 'Rủi ro thừa cân và béo phì',
        tcm_syndromes: ['Đàm thấp nội uẩn', 'Tỳ hư đàm thấp']
    }
};

// Risk level thresholds
export const RISK_LEVELS = {
    VERY_LOW: { min: 0, max: 20, label: 'Rất thấp', color: '#10B981', bgColor: '#D1FAE5' },
    LOW: { min: 21, max: 40, label: 'Thấp', color: '#22C55E', bgColor: '#DCFCE7' },
    MODERATE: { min: 41, max: 60, label: 'Trung bình', color: '#F59E0B', bgColor: '#FEF3C7' },
    HIGH: { min: 61, max: 80, label: 'Cao', color: '#F97316', bgColor: '#FFEDD5' },
    VERY_HIGH: { min: 81, max: 100, label: 'Rất cao', color: '#EF4444', bgColor: '#FEE2E2' }
};

/**
 * Get risk level based on score
 * @param {number} score - Risk score 0-100
 * @returns {object} Risk level object
 */
export function getRiskLevel(score) {
    if (score <= 20) return RISK_LEVELS.VERY_LOW;
    if (score <= 40) return RISK_LEVELS.LOW;
    if (score <= 60) return RISK_LEVELS.MODERATE;
    if (score <= 80) return RISK_LEVELS.HIGH;
    return RISK_LEVELS.VERY_HIGH;
}

/**
 * Get categories by system
 * @param {string} systemId - System ID
 * @returns {array} Array of risk categories
 */
export function getCategoriesBySystem(systemId) {
    return Object.values(RISK_CATEGORIES).filter(cat => cat.system === systemId);
}

/**
 * Group risks by severity
 * @param {object} riskScores - Object with category IDs and scores
 * @returns {object} Grouped risks { high: [], medium: [], low: [] }
 */
export function groupRisksBySeverity(riskScores) {
    const result = { high: [], medium: [], low: [] };

    Object.entries(riskScores).forEach(([categoryId, score]) => {
        const category = RISK_CATEGORIES[categoryId];
        if (!category) return;

        const item = { ...category, score };

        if (score >= 60) {
            result.high.push(item);
        } else if (score >= 40) {
            result.medium.push(item);
        } else {
            result.low.push(item);
        }
    });

    // Sort by score descending
    result.high.sort((a, b) => b.score - a.score);
    result.medium.sort((a, b) => b.score - a.score);
    result.low.sort((a, b) => b.score - a.score);

    return result;
}
